import React, { useContext } from 'react';



import CasHeader from '../components/common/CasHeader';
import CasSidebar from '../components/common/CasSidebar';
import CasFooter from '../components/common/CasFooter';
import { AuthRoutes } from '../components/AuthRoutes';
import { AuthContext } from 'orinabiji-auth-react';

export function HomeAuth() {
  const { userInfo, logOut } = useContext(AuthContext);

  return (
    <>
      {userInfo ?
        <>
          <CasHeader userInfo={userInfo} logOut={logOut} />
          <div className="cas-wrapper">
            <CasSidebar userInfo={userInfo} logOut={logOut} />
            <AuthRoutes />
          </div>
          <CasFooter />
        </> : <></>
      }
    </>
  );
}

export default HomeAuth;
